import types from './types'

const fetchingLicenses = () => ({ type: types.FETCHING_LICENSES })

const fetchingLicensesError = (
  error = 'There was a problem loading your licenses. Please try again later.',
) => ({ type: types.FETCHING_LICENSES_ERROR, error })

const fetchingLicensesSuccess = licenses => ({
  type: types.FETCHING_LICENSES_SUCCESS,
  licenses,
})

const sendingLicenseInvite = ({ isReminder = false }) => ({
  type: types.SENDING_LICENSE_USER,
  isReminder,
})

const sendingLicenseInviteError = ({
  customError = 'There was a problem submitting an invite license users.',
  licenseId,
  role,
  isReminder = false,
  email,
}) => ({
  type: types.SENDING_LICENSE_USER_ERROR,
  error: customError,
  licenseId,
  role,
  email,
  isReminder,
})

const sendingLicenseInviteSuccess = ({
  licenseUserPayload,
  licenseId,
  role,
  email,
  isReminder = false,
}) => ({
  type: types.SENDING_LICENSE_USER_SUCCESS,
  licenseUserPayload,
  licenseId,
  role,
  email,
  isReminder,
})

const sendingLicenseInviteBulk = () => ({
  type: types.SENDING_LICENSE_USER_BULK,
})

const sendingLicenseInviteBulkError = (
  error = 'There was a problem submitting an invite license users.',
  licenseId,
  role,
) => ({
  type: types.SENDING_LICENSE_USER_BULK_ERROR,
  error,
  licenseId,
  role,
})

const sendingLicenseInviteBulkSuccess = ({ results }) => ({
  type: types.SENDING_LICENSE_USER_BULK_SUCCESS,
  results,
})

const sendingLicenseAssignment = () => ({
  type: types.SENDING_LICENSE_ASSIGNMENT,
})

const sendingLicenseAssignmentError = (
  error = 'Failed to send License Assignment',
) => ({
  type: types.SENDING_LICENSE_ASSIGNMENT_ERROR,
  error,
})

const sendingLicenseAssignmentSuccess = (license, subscriptionId) => ({
  type: types.SENDING_LICENSE_ASSIGNMENT_SUCCESS,
  license,
  subscriptionId,
})

const setSelectedUserLicense = selectedLicenseId => ({
  type: types.SET_SELECTED_USER_LICENSE,
  selectedLicenseId,
})

const updateUserLicenseRemoveUser = (email, licenseId, userId) => ({
  type: types.UPDATE_USER_LICENSE_REMOVE_USER,
  email,
  licenseId,
  userId,
})

const grantingNewRoleLicenseUser = isActive => ({
  type: types.GRANTING_NEW_ROLE_LICENSE_USER,
  isActive,
})

const grantingNewRoleLicenseUserError = (
  error = 'Failed to grant user the new role',
) => ({
  type: types.GRANTING_NEW_ROLE_LICENSE_USER_ERROR,
  error,
})

const grantingNewRoleLicenseUserSuccess = (email, licenseId, roles) => ({
  type: types.GRANTING_NEW_ROLE_LICENSE_USER_SUCCESS,
  email,
  licenseId,
  roles,
})

const resetBulkUsersAdd = () => ({
  type: types.RESET_BULK_ADD_USERS,
})

const startAddUser = payload => ({
  type: types.START_ADD_USER,
  payload,
})

const endAddUser = payload => ({
  type: types.END_ADD_USERS,
  payload,
})
const switchAddUserMode = payload => ({
  type: types.SWITCH_ADD_USER_MODE,
  payload,
})

export default {
  fetchingLicenses,
  fetchingLicensesError,
  fetchingLicensesSuccess,
  sendingLicenseInvite,
  sendingLicenseInviteError,
  sendingLicenseInviteSuccess,
  sendingLicenseInviteBulk,
  sendingLicenseInviteBulkError,
  sendingLicenseInviteBulkSuccess,
  sendingLicenseAssignment,
  sendingLicenseAssignmentError,
  sendingLicenseAssignmentSuccess,
  setSelectedUserLicense,
  updateUserLicenseRemoveUser,
  grantingNewRoleLicenseUser,
  grantingNewRoleLicenseUserError,
  grantingNewRoleLicenseUserSuccess,
  resetBulkUsersAdd,
  startAddUser,
  endAddUser,
  switchAddUserMode,
}
